const urlParams = new URLSearchParams(window.location.search);
const isWebSite = urlParams.get('website');

export default function() {
  return isWebSite;
}

export function getUrl(path) {
  return `/dashboard/mobile_app/${path}`;
}
